module.exports = __webpack_public_path__ + "img/lunch-dashboard.a5ffcfc1.jpg";